import React from 'react';
import { FormControl, InputLabel, ListSubheader, MenuItem, Select } from '@mui/material';
import { getArchLayout, getToothName } from '../../constants/odontology';

export interface ToothSelectProps {
  value: string;
  onChange: (toothNumber: string) => void;
  label?: string;
  disabled?: boolean;
  includeDeciduous?: boolean;
}

/** Seletor de dente em notação FDI, agrupado por arcada. */
const ToothSelect: React.FC<ToothSelectProps> = ({
  value,
  onChange,
  label = 'Dente',
  disabled = false,
  includeDeciduous = true,
}) => {
  const permanent = getArchLayout('permanent');
  const deciduous = getArchLayout('deciduous');

  const groups = [
    { label: 'Permanentes — superior', teeth: [...permanent.upper.right, ...permanent.upper.left] },
    { label: 'Permanentes — inferior', teeth: [...permanent.lower.right, ...permanent.lower.left] },
    ...(includeDeciduous
      ? [
        { label: 'Decíduos — superior', teeth: [...deciduous.upper.right, ...deciduous.upper.left] },
        { label: 'Decíduos — inferior', teeth: [...deciduous.lower.right, ...deciduous.lower.left] },
      ]
      : []),
  ];

  return (
    <FormControl fullWidth size="small" disabled={disabled}>
      <InputLabel id="tooth-select-label">{label}</InputLabel>
      <Select
        labelId="tooth-select-label"
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="">Selecione</MenuItem>
        {groups.flatMap((group) => [
          <ListSubheader key={group.label} sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#94A3B8' }}>
            {group.label}
          </ListSubheader>,
          ...group.teeth.map((tooth) => (
            <MenuItem key={tooth} value={tooth}>
              {tooth} — {getToothName(tooth)}
            </MenuItem>
          )),
        ])}
      </Select>
    </FormControl>
  );
};

export default ToothSelect;
